<ion-list lines="none">
  <ion-item class="permalink-actions">
    <ion-label>Trainee Link</ion-label>
    <div class="tooltip-open">
      <ion-button (click)="openLink('trainee')" slot="end" size="small" fill="clear" color="secondary">
        <ion-icon slot="icon-only" name="open-outline"></ion-icon>
      </ion-button>
    </div>
    <div class="tooltip-copy">
      <ion-button (click)="copyLink('trainee')" slot="end" size="small" fill="clear" color="secondary">
        <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-item>
  <ion-item class="permalink-actions">
    <ion-label>Admin Link</ion-label>
    <div class="tooltip-open">
      <ion-button (click)="openLink('admin')" slot="end" size="small" fill="clear" color="secondary">
        <ion-icon slot="icon-only" name="open-outline"></ion-icon>
      </ion-button>
    </div>
    <div class="tooltip-copy">
      <ion-button (click)="copyLink('admin')" slot="end" size="small" fill="clear" color="secondary">
        <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
      </ion-button>
    </div>
  </ion-item>
</ion-list>
